/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react'

import { Carousel } from 'src/components/Carousel/Carousel'
import { ShopifyImage } from 'src/components/ShopifyImage/ShopifyImage'

import styles from './ProductPhotoCarousel.module.scss'

import type { Embla } from '@mantine/carousel'
import type { Product, ProductVariant, Image, MediaImage, Video } from 'src/data/graphql-generated'

interface ProductPhotoCarouselProps {
  images: Partial<Image | MediaImage | Video>[]
  productName: Product['title']
  variantName: ProductVariant['title']
}

export const ProductPhotoCarousel = ({ images, productName, variantName }: ProductPhotoCarouselProps) => {
  const [embla, setEmbla] = useState<Embla | null>(null)

  useEffect(() => {
    if (embla) {
      embla.scrollTo(0, true)
    }
  }, [embla, variantName])

  return (
    <div className={styles.container}>
      <Carousel
        variant="cards"
        withIndicators={images?.length > 1}
        getEmblaApi={setEmbla}
        classNames={{ root: styles.carouselRoot }}
        slideSize={{ base: '100%', md: '50%' }}
      >
        {images?.map((media, i) => {
          if (media.__typename === 'Image') {
            return (
              <div key={media.id} className={styles.imageWrapper}>
                <ShopifyImage
                  image={media}
                  alt={`${productName} ${variantName}`}
                  className={styles.image}
                  height={450}
                  width={450}
                  preload={i === 0}
                />
              </div>
            )
          }
          if (media.__typename === 'MediaImage') {
            return (
              <div key={media.image?.id} className={styles.imageWrapper}>
                <ShopifyImage
                  image={media.image}
                  alt={`${productName} ${variantName}`}
                  className={styles.image}
                  height={450}
                  width={450}
                  preload={i === 0}
                />
              </div>
            )
          }
          if (media.__typename === 'Video') {
            return (
              <div key={media.id} className={styles.imageWrapper}>
                <video preload="none" key={media.id} playsInline muted loop autoPlay className={styles.video}>
                  <source src={media.sources?.[0].url} type="video/mp4" />
                </video>
              </div>
            )
          }
          return null
        })}
      </Carousel>
    </div>
  )
}
